import React from "react";
import Error from "../assets/CCstatics/error.png";
import "../assets/css/App.css";
import { Link } from "react-router-dom";
Link;

function P404() {
  return (
    <>
      <div className="errorLoco">
        <img src={Error} alt="" />
        <p>
          ¡Uyy, algo salió mal! <br /> La página que estás buscando no existe.
        </p>
        <Link to="/">IR AL HOME</Link>
      </div>
    </>
  );
}

export default P404;
